var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VehicleIdentification"},[_c('div',{staticClass:"left"},[_c('Left')],1),_c('div',{staticClass:"middle"},[_c('Middle')],1),_c('div',{staticClass:"right"},[_c('Right')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }